export default "__VITE_ASSET__6432a09a__"